module.exports = __webpack_public_path__ + "img/dumpthecombo.c096760e.png";